module.exports = __webpack_public_path__ + "img/28ec749.png";